import ReactSelect from "react-select";

/**
 * react-select, with stable class names so the dashboard can theme it.
 *
 * WHY THIS EXISTS. react-select styles itself with emotion, so its control and
 * menu are painted white by the library regardless of the page theme. In dark
 * mode every one of these was a white box in a row of dark native `<select>`s
 * — the المطاعم filter on the orders screen being the obvious one — and the
 * open menu was a white sheet over a dark page.
 *
 * Nothing here can be fixed from a stylesheet without a class name to aim at:
 * emotion's generated names (`css-13cymwt-control`) carry a build hash, and
 * matching them with `[class*="-control"]` would silently stop working on a
 * react-select upgrade. `classNamePrefix` is the library's supported answer,
 * and putting it in one wrapper rather than on 35 call sites means a component
 * added tomorrow gets the theme by importing this instead of remembering a prop.
 *
 * Styles live in `index.scss` under `.dark .rs__*`, next to the other dark
 * overrides rather than here, since they are theme rules and not behaviour.
 *
 * Drop-in for the default export of react-select: every prop is forwarded, and
 * an explicit `classNamePrefix` still wins if a call site needs its own.
 */
const SelectField = (props) => <ReactSelect classNamePrefix="rs" {...props} />;

export default SelectField;
